import { UAT_CONSTANTS } from './environment.constants.uat';
import { PROD_CONSTANTS } from './environment.constants.prod';
import { DEV_CONSTANTS } from './environment.constants.dev';

// environment properties from hostname
const { location  } = window;
const { hostname  } = location;
const clientPortalHostname = 'clientportal.cambridgeassociates.com';
const isProd = hostname === clientPortalHostname;
const isSandbox = !isProd && ['localhost', '127.0.0.1'].includes(hostname);
const environment = isProd ? 'prod' : (isSandbox ? 'dev' : hostname.split(`.${clientPortalHostname}`)[0]);


// gets specific environment property
const getEnvironmentProperty = (targetEnvironment: 'dev' | 'uat' | 'prod', property: string): any => {
    const environmentMap = {
        dev: DEV_CONSTANTS,
        uat: UAT_CONSTANTS,
        prod: PROD_CONSTANTS,
    };
    return environmentMap[targetEnvironment][property] || '';
};

// sandbox environment flag
export const IS_SANDBOX_ENVIRONMENT = isSandbox;


// deployed env
export const DEPLOYED_ENV = environment as 'dev' | 'uat' | 'prod';


// lower environment flag
export const IS_LOWER_ENVIRONMENT = environment !== 'prod';

// DATA DOG properties
export const DATA_DOG_SITE = 'datadoghq.com';
export const DATA_DOG_VERSION = '1.0';
export const DATA_DOG_SERVICE = getEnvironmentProperty(DEPLOYED_ENV, 'DATA_DOG_SERVICE');
export const DATA_DOG_APP_ID = atob(getEnvironmentProperty(DEPLOYED_ENV, 'DATA_DOG_APP_ID'));
export const DATA_DOG_CLIENT_TOKEN = atob(getEnvironmentProperty(DEPLOYED_ENV, 'DATA_DOG_CLIENT_TOKEN'));


// MSAL properties
export const MSAL_TENANT = getEnvironmentProperty(DEPLOYED_ENV, 'MSAL_TENANT');
export const MSAL_CLIENT_ID = getEnvironmentProperty(DEPLOYED_ENV, 'MSAL_CLIENT_ID');
export const MSAL_REDIRECT_URL = isSandbox ? 'http://localhost:3000' : getEnvironmentProperty(DEPLOYED_ENV, 'MSAL_REDIRECT_URL');


// API properties
export const API_BASE_URL = isSandbox ? 'http://localhost:5000/api/exp' : getEnvironmentProperty(DEPLOYED_ENV, 'API_BASE_URL');
export const EMMA_API_BASE_URL = isSandbox ? 'http://localhost:8080/api/emma' : getEnvironmentProperty(DEPLOYED_ENV, 'EMMA_API_BASE_URL');


// iLevel links
export const ILEVEL_CA_EMPLOYEE_URL = getEnvironmentProperty(DEPLOYED_ENV, 'ILEVEL_CA_EMPLOYEE_URL');
export const ILEVEL_CLIENT_CONTACT_URL = getEnvironmentProperty(DEPLOYED_ENV, 'ILEVEL_CLIENT_CONTACT_URL');


// PW links
export const PW_CA_EMPLOYEE_URL = getEnvironmentProperty(DEPLOYED_ENV, 'PW_CA_EMPLOYEE_URL');
export const PW_CLIENT_CONTACT_LINK_URL = getEnvironmentProperty(DEPLOYED_ENV, 'PW_CLIENT_CONTACT_LINK_URL');


// more links
export const MORE_LINKS = getEnvironmentProperty(DEPLOYED_ENV, 'MORE_LINKS');


// document upload notification delay in minutes
export const UPLOAD_NOTIFICATION_EMAIL_DELAY_IN_MINUTES = getEnvironmentProperty(DEPLOYED_ENV, 'UPLOAD_NOTIFICATION_EMAIL_DELAY_IN_MINUTES');


// image bucket properties
export const IMAGE_BUCKET_BASE_PATH = isSandbox ? 'https://dev.clientportal.cambridgeassociates.com/img/'
    : getEnvironmentProperty(DEPLOYED_ENV, 'IMAGE_BUCKET_BASE_PATH');


// media content upload limits
export const VIDEO_MAX_UPLOAD_SIZE = getEnvironmentProperty(DEPLOYED_ENV, 'VIDEO_MAX_UPLOAD_SIZE');
export const IMAGE_MAX_SIZE = 5242880;
export const AUDIO_MAX_SIZE = 104857600;
